import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { Link } from '../../routes';
import IndexPageSection from '../IndexPageSection';
import WaysCard from '../WaysCard';
import WaysBigCard from '../WaysBigCard';
import WaysGoldCard from '../WaysGoldCard';
import { WaysList, WaysItem } from "./styles";
import { slugify, getCategory, getAllProductNamesString } from '../../utils';

import DaypassImage from '../../assets/img/daypass.jpg';

const WaysToDaycation = ({ categories, city, date, guests, priceHi, priceLo, distanceHi, distanceLo, sortType }) => (
  <IndexPageSection id="ways-to-daycation" heading={<Fragment><span>Ways</span> to daycation</Fragment>}>
    <WaysList>
      <WaysItem>
        <Link
          route="search"
          params={{
            marketName: slugify(city.market),
            category: getCategory('Day Pass'),
            product: getAllProductNamesString(),
            market: city.label,
            date: moment(date).format('YYYY-MM-DD'),
            guests,
            priceHi: priceHi || 300,
            priceLo: priceLo || 0,
            distanceHi: distanceHi || 0,
            distanceLo: distanceLo || 0,
            sortType: sortType || 2,
            experience: 'Festive,Family,Tranquil',
          }}
        >
          <a target="_blank" rel="noopener noreferrer">
            <WaysBigCard heading="Day Passes" price={15} img={DaypassImage} />
          </a>
        </Link>
      </WaysItem>
      {categories.slice(1).map(category => (
        <WaysItem key={category.name}>
          <Link
            route="search"
            params={{
              marketName: slugify(city.market),
              category: getCategory(category.name),
              product: category.name,
              market: city.label,
              date: moment(date).format('YYYY-MM-DD'),
              guests,
              priceHi: priceHi || 300,
              priceLo: priceLo || 0,
              distanceHi: distanceHi || 0,
              distanceLo: distanceLo || 0,
              sortType: sortType || 2,
              experience: 'Festive,Family,Tranquil',
            }}
          >
            <a target="_blank" rel="noopener noreferrer">
              <WaysCard textColor="white" heading={category.description} price={category.price} img={`/static/images/categories/${category.image}`} />
            </a>
          </Link>
        </WaysItem>
      ))}
      <WaysItem>
        <Link href="https://www.blog.dayaxe.com/goldpass">
          <a>
            <WaysGoldCard heading="Gold Pass" description="Special monthly premium subscription. Gives you unlimited use daypass." />
          </a>
        </Link>
      </WaysItem>
    </WaysList>
  </IndexPageSection>
);
WaysToDaycation.propTypes = {
  categories: PropTypes.instanceOf(Array),
  city: PropTypes.instanceOf(Object),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  priceHi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceLo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distanceHi: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  distanceLo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  guests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const mapStateToProps = state => ({
  city: state.userPreferences.city,
  date: state.userPreferences.date,
  guests: state.userPreferences.guests,
  priceHi: state.userPreferences.price.priceHi,
  priceLo: state.userPreferences.price.priceLo,
  distanceHi: state.userPreferences.distance.distanceHi,
  distanceLo: state.userPreferences.distance.distanceLo,
  sortType: state.userPreferences.distance.sortType,
});

export default connect(mapStateToProps)(WaysToDaycation);
